const variants = {
  primary: {
    main: () => ({
      backgroundColor: 'var(--color-primary-500)',
      outline: 'var(--border-primary-thin)',
      color: 'var(--color-contrast-primary-500)',
      stroke: 'var(--color-contrast-primary-500)',
      '&:hover': {
        backgroundColor: 'var(--color-primary-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-primary-100)',
        outlineColor: 'var(--color-primary-200)'
      },
      '& .__progress': {
        color: 'var(--color-contrast-primary-500)',
        stroke: 'var(--color-contrast-primary-500)'
      }
    }),
    warning: () => ({
      backgroundColor: 'var(--color-danger-500)',
      outline: '1.5px solid var(--color-danger-050)',
      color: 'var(--color-contrast-danger-500)',
      stroke: 'var(--color-danger-500)',
      '&:hover': {
        backgroundColor: 'var(--color-danger-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-danger-200)'
      },
      '& .__progress': {
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      }
    })
  },

  secondary: {
    main: () => ({
      backgroundColor: 'var(--color-neutral-500)',
      outline: '1.5px solid var(--color-neutral-600)',
      color: 'var(--color-contrast-neutral-500)',
      stroke: 'var(--color-contrast-neutral-500)',
      '&:hover': {
        backgroundColor: 'var(--color-neutral-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-neutral-100)',
        outline: '1.5px solid var(--color-neutral-200)'
      },
      '& .__progress': {
        color: 'var(--color-contrast-neutral-500)',
        stroke: 'var(--color-contrast-neutral-500)'
      }
    }),
    warning: () => ({
      backgroundColor: 'var(--color-danger-050)',
      outline: '1.5px solid var(--color-danger-050)',
      color: 'var(--color-danger-500)',
      stroke: 'var(--color-danger-500)',
      '&:hover': {
        backgroundColor: 'var(--color-danger-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-danger-200)'
      },
      '& .__progress': {
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      }
    })
  },

  outline: {
    main: () => ({
      backgroundColor: 'var(--theme-color-surface-d0)',
      outline: '1.5px solid var(--color-primary-500)',
      color: 'var(--color-primary-500)',
      stroke: 'var(--color-primary-500)',
      '&:hover': {
        backgroundColor: 'var(--color-primary-500)',
        color: 'var(--color-primary-050)',
        stroke: 'var(--color-primary-050)'
      },
      '&:disabled': {
        outline: '1.5px solid var(--color-primary-200)',
        color: 'var(--color-primary-200)',
        stroke: 'var(--color-primary-200)'
      },
      '& .__progress': {
        color: 'var(--color-primary-500)',
        stroke: 'var(--color-primary-500)'
      }
    }),
    warning: () => ({
      backgroundColor: 'var(--theme-color-surface-d0)',
      outline: '1.5px solid var(--color-danger-500)',
      color: 'var(--color-danger-500)',
      stroke: 'var(--color-danger-500)',
      '&:hover': {
        backgroundColor: 'var(--color-danger-500)',
        color: 'var(--color-danger-050)',
        stroke: 'var(--color-danger-050)'
      },
      '&:disabled': {
        color: 'var(--color-danger-200)',
        stroke: 'var(--color-danger-200)'
      },
      '& .__progress': {
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      }
    })
  },

  ghost: {
    main: () => ({
      backgroundColor: 'transparent',
      outline: 'none',
      color: 'var(--color-primary-500)',
      stroke: 'var(--color-primary-500)',
      '&:hover': {
      },
      '&:disabled': {
        color: 'var(--text-color-disabled)',
        stroke: 'var(--text-color-disabled)'
      },
      '& .__progress': {
        color: 'var(--color-primary-500)',
        stroke: 'var(--color-primary-500)'
      }
    }),
    warning: () => ({
      backgroundColor: 'transparent',
      outline: 'none',
      color: 'var(--color-danger-500)',
      stroke: 'var(--color-danger-500)',
      '&:hover': {
        backgroundColor: 'var(--color-danger-600)',
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      },
      '&:disabled': {
        color: 'var(--color-danger-200)',
        stroke: 'var(--color-danger-200)'
      },
      '& .__progress': {
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      }
    })
  },

  ai: {
    main: () => ({
      backgroundColor: 'var(--color-ai-500)',
      outline: 'var(--border-primary-thin)',
      color: 'var(--color-contrast-ai-500)',
      stroke: 'var(--color-contrast-ai-500)',
      '&:hover': {
        backgroundColor: 'var(--color-ai-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-ai-100)',
        outlineColor: 'var(--color-ai-200)'
      },
      '& .__progress': {
        color: 'var(--color-contrast-ai-500)',
        stroke: 'var(--color-contrast-ai-500)'
      }
    }),
    warning: () => ({
      backgroundColor: 'var(--color-danger-500)',
      outline: '1.5px solid var(--color-danger-050)',
      color: 'var(--color-contrast-danger-500)',
      stroke: 'var(--color-danger-500)',
      '&:hover': {
        backgroundColor: 'var(--color-danger-600)'
      },
      '&:disabled': {
        backgroundColor: 'var(--color-danger-200)'
      },
      '& .__progress': {
        color: 'var(--color-danger-500)',
        stroke: 'var(--color-danger-500)'
      }
    })
  }
}

const sizes = {
  xs: (theme) => ({
    padding: '2px 12px',
    minHeight: '16px',
    lineHeight: '16px',
    fontSize: theme.typography.fontSizes.xs
  }),
  sm: (theme) => ({
    padding: '2px 20px',
    minHeight: '20px',
    lineHeight: '20px',
    fontSize: theme.typography.fontSizes.md
  }),
  md: (theme) => ({
    padding: '4px 24px',
    minHeight: '32px',
    lineHeight: '32px',
    fontSize: theme.typography.fontSizes.xl
  }),
  lg: (theme) => ({
    padding: '5px 32px',
    minHeight: '40px',
    lineHeight: '40px',
    fontSize: theme.typography.fontSizes.h5
  }),
  xl: (theme) => ({
    padding: '5px 32px',
    minWidth: '300px',
    minHeight: '40px',
    lineHeight: '40px',
    fontSize: theme.typography.fontSizes.h4
  })
}

export const mapButtonStyles = (theme, rest) => ({ variant, priority, size }) => ({
  ...rest,
  ...variants[variant][priority](theme),
  ...sizes[size](theme)
})
